import React, { useEffect, useState } from 'react';
import { Layout, message, Table, Tag, Popconfirm, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import styles from './VideoListStyle.module.scss';
import { useSelector, useDispatch } from 'react-redux';
import { errorToast, getUserShortName, infoToast, toISODate } from '../../api/Util';
import { getAllCardsByTimePeriod, deleteCardById } from '../../services/cardsService';
import "./VideoListStyle.scss";
import { getStatusAndColor } from '../../api/Util';
import CustomDropdown from '../common/CustomDropdown/DropDown';
import { TimePeriod } from '../constant/DropdownData';
import TopHeader from '../TopHeader';
import { fetchWebsiteCardsCount } from '../../actions';
import { ADMIN, CUSTOMER } from '../../api/Constants';
const INITIAL_FILTER_STATE = {
  timeRange: "current_month",
  viewAs:"All Customers",
}

const VideoList = () => {
  const props = useSelector((state) => state)
  const dispatch = useDispatch();
  const [filterCards, setFilterCards] = useState(INITIAL_FILTER_STATE);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalVideoCreditCount, setTotalVideoCreditCount] = useState(0);
  const authUser = props.auth?.loggedInUser;
  const websiteUsers = useSelector(state => state.allWebsiteUsers.website_users);
  const [options, setOptions] = useState([]);

  const columns = [
    {
      title: 'Card Title',
      dataIndex: 'cardTitle',
      key: 'cardTitle',
      width: 300,
    },
    {
      title: 'Tag Type',
      dataIndex: 'videoTagType',
      key: 'videoTagType',
      width: 100,
    },
    {
      title: 'Video Count',
      dataIndex: 'videoCount',
      key: 'videoCount',
      width: 100,
    },
    {
      title: 'Credit Count',
      dataIndex: 'creditCount',
      key: 'creditCount',
      width: 100,
    },
    {
      title: 'Customer',
      dataIndex: 'customer',
      key: 'customer',
      width: 100,
    },
    {
      title: 'QA',
      dataIndex: 'qa',
      key: 'qa',
      width: 100,
    },
    {
      title: 'Team Lead',
      dataIndex: 'teamLead',
      key: 'teamLead',
      width: 100,
    },
    {
      title: 'Creation Date',
      dataIndex: 'creationDate',
      key: 'creationDate',
      width: 100,
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 100,
      render: ((status) => {
        const statusAndColor = getStatusAndColor(status);
        return (
          <Tag color={statusAndColor?.color} key={statusAndColor?.label}>
            {statusAndColor?.label?.toUpperCase()}
          </Tag>
        )
      }),
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: 'action',
      width: 100,
      render: (text, record) => (
        <Popconfirm
          title="Are you sure you want to delete this card?"
          onConfirm={() => handleDelete(record.cardId)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} />
        </Popconfirm>
      ),
    },
  ];

  const getCards = async () => {
    infoToast("Loading");
    const response = await getAllCardsByTimePeriod(filterCards);
    if (response.status) {
      const filteredData = response.data?.cards?.map((item, i) => ({
        key: i + 1,
        cardTitle: item.card_title,
        videoTagType: item?.video_tag_type,
        videoCount: item?.video_list_tag_type_count,
        creditCount: item?.creditCount,
        customer: item?.client_fullname,
        qa: getUserShortName(item?.qa_fullname)|| "--",
        teamLead: getUserShortName(item?.lead_fullname) || "--",
        creationDate: toISODate(item?.creation_time),
        status: item?.card_status,
        cardId: item?.card_id,
      }))
      setTableData(filteredData);
      setTotalCount(response.data.cards?.length);
      setTotalVideoCreditCount(response.data.totalVideoCreditCount)
    } else {
      errorToast("Something went wrong");
    }
  }

  const setTimePeriod = (value) => {
    setFilterCards({ ...filterCards, timeRange: value });
  }

  const setCustomerViewAs = (value) => {
    const newValue = value ? value : "All Customers";
    setFilterCards({ ...filterCards, viewAs: newValue });
  }

  useEffect(() => {
    getCards();
  }, [filterCards])

  useEffect(() => {
    var option;
    option = (websiteUsers || [])
      ?.filter((user) => user.client_type === CUSTOMER)
      .map((user) => {
        return {
          value: `${user.client_id}`,
          label: `${user.fullname} (${user.client_type})`,
          className: user?.is_deleted ? 'deleted-user' : '',
        };
      });
    setOptions(option);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteUsers]);

  const handleDelete = async (cardId) => {
    try {
      infoToast("Deleting card...");
      const response = await deleteCardById(cardId);
      if (response.status) {
        getCards();
        dispatch(fetchWebsiteCardsCount());
        message.success("Card deleted successfully.");
      } else {
        errorToast("Failed to delete the card.");
      }
    } catch (error) {
      console.error("Error deleting card:", error);
      errorToast("Something went wrong while deleting the card.");
    }
  };


  return (
    <Layout className={styles.homeLayout}>
      <div className="aside-right-top-bar all-customer-topbar">
        <div className="top-bar-left">
          <div className="top_bar">
            <h3>Video List</h3>
          </div>
        </div>
        <div className="top-bar-right">
          <TopHeader />
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.filtersAndTotalCount}>
          <div className={styles.selectBoxWrapper}>
            <div>
              <CustomDropdown
                options={TimePeriod}
                placeholder="Select Time Period"
                className={styles.viewAsStyle}
                dropdownValue={filterCards.timeRange}
                handleOnchange={setTimePeriod}
              />
            </div>
            <CustomDropdown
              options={options}
              placeholder="Select Customer"
              className={styles.viewAsStyle}
              dropdownValue={filterCards.viewAs === "All Customers" ? undefined : filterCards.viewAs}
              handleOnchange={setCustomerViewAs}
            />
            {
              <div className={styles.totalCountDiv}>
                <Typography.Text className={styles.totalCount}>
                  Total Card Count ({totalCount})
                </Typography.Text>
              </div>
            }
            <div className={styles.totalCountDiv}>
              <Typography.Text className={styles.totalCount}>
                ||
              </Typography.Text>
            </div>
            {
              <div className={styles.totalCountDiv}>
                <Typography.Text className={styles.totalCount}>
                  Total Credit Count ({totalVideoCreditCount})
                </Typography.Text>
              </div>
            }
          </div>
        </div>
        <div className={styles.tableDiv}>
          <Table
            className={styles.customizeTable}
            columns={columns}
            dataSource={tableData}
            pagination={{ pageSize: 100 }}
          />
        </div>
      </div>
    </Layout>
  );
}

export default VideoList;
